import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { store } from '@/store';
import PaymentProviderAdyen from '@/ui/views/checkout/PaymentProviderAdyen.vue';
import PaymentProviderPaypal from '@/ui/views/checkout/PaymentProviderPaypal.vue';
import CheckoutProgress from '@/ui/views/checkout/CheckoutProgress.vue';
import PaymentSummaryB2C from '@/ui/views/checkout/PaymentSummaryB2C.vue';
import { SiteMode } from './site-mode';
import { PaymentProvider } from '@/enums';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentB2C',
  props: {
    paymentProvider: null
  },
  setup(__props: any) {

const props = __props as {paymentProvider: number}



const isAdyen = computed<boolean>(() => props.paymentProvider === PaymentProvider.Adyen);
const isPaypal = computed<boolean>(() => props.paymentProvider === PaymentProvider.Paypal);

const basket = computed<BasketViewModel>(() => store.getters['basket/basket']);

const siteMode = SiteMode;

return { __sfc: true,props, isAdyen, isPaypal, basket, siteMode, PaymentProviderAdyen, PaymentProviderPaypal, CheckoutProgress, PaymentSummaryB2C }
}

})